import React from "react";
import { PeekBox } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import ToggleSwitch from "@components/common/form/toggle-switch";
const EmbedCodeToggleSwitch = (props) => {
    const intl = useIntl();
    return (React.createElement(PeekBox, { width: 160 },
        React.createElement(ToggleSwitch, Object.assign({ onLabel: intl.formatMessage(messages.spaceEmbedCodeFormToggleSwitchShow), offLabel: intl.formatMessage(messages.spaceEmbedCodeFormToggleSwitchHide) }, props))));
};
export default EmbedCodeToggleSwitch;
